import { render, staticRenderFns } from "./TableStaff.vue?vue&type=template&id=6a2bafcd"
import script from "./TableStaff.vue?vue&type=script&lang=js"
export * from "./TableStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports